var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.routes),function(item){return _c('span',{key:item.id},[_c('a',{staticClass:"breadcrumb-link",attrs:{"href":"#"},on:{"click":function($event){return _vm.onClick(item.id)}}},[_vm._v(_vm._s(item.name))]),_vm._v("/ ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }